@use "~theme/typography";
@use "~theme/breakpoints";

$round-bottom: 0 0 4px 4px;

.doctorPanel {
  display: flex;
  margin: 20px auto;
  width: fit-content;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid var(--gray-04);
  box-shadow: 0 2px 6px var(--gray-03);
  background-color: var(--white);
}

.carousel {
  display: flex;
  flex-flow: row nowrap;
  max-width: 860px;
  background-color: var(--white);
  overflow-x: auto;
  cursor: pointer;
  position: relative;
  white-space: nowrap;
  scroll-snap-type: x mandatory;
}

.nav {
  width: 40px;
  display: flex;
  background-color: var(--blue-03);
  flex: 1;
  outline: none;
  border: none;
  justify-content: center;
  align-items: center;
  margin: 8px;
  cursor: pointer;

  &:focus-within {
    filter: drop-shadow(0 0 12px var(--hightlight-blue));
  }
}

.nav:active,
.nav:hover {
  outline: none;
}

.navDisabled {
  background-color: var(--gray-04);
  cursor: auto;
}

.doctors {
  cursor: pointer;
  display: flex;
  position: relative;
  width: fit-content;

  // Gray track in which the active doctor "indicator" sits.
  &::after {
    position: absolute;
    content: "";
    top: 0;
    left: 4px;
    right: 4px;
    height: 4px;
    border-radius: $round-bottom;
    background-color: var(--gray-03);
  }
}

.button {
  background-color: var(--blue-01);
  width: 24px;
  height: 24px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.navDisabled .button {
  background-color: var(--gray-01);
}

.buttonLeft {
  margin-left: 4px;
}

.buttonRight {
  margin-right: 4px;
}

.noAvailableDoctors {
  font-size: 18px;
  font-weight: 600;
  line-height: 140%;
  letter-spacing: 0.02em;
  color: var(--black);
  width: 100%;
  text-align: center;
  background: #FFFFFF;
  border: 0.5px solid rgba(0, 0, 0, 0.2);
  border-radius: 4px;

  p {
    max-width: 100%;
    margin: 50px 24%;
    text-align: center;
    padding: 0;
  }

  a {
    text-decoration: underline;
    cursor: pointer;
  }
}


.doctorTimeSlotContainer{
    background: #FFFFFF;
    border: 0.5px solid rgba(0, 0, 0, 0.2);
    border-radius: 4px;
    padding: 10px;
    display: block;
    overflow: auto;
}

.contentLeft {
    width:25%;
    float:left;
    height: 100%;
    max-height: 100%;
}

.contentRight {
    width:75%;
    float:left;
    height: 100%;
    max-height: 100%;
}

.avatar {
  border-radius: 50%;
  width: 74px;
  height: 74px;
  background-size: 74px;
  background-color: var(--blue-02-at-30);
}

.small {
    width: 48px;
    height: 48px;
}

.limitedAvailability{
  width: 19%;
  height: 150px;
  left: 41px;
  top: 1127px;
  background: #FFFFFF;
  border: 0.5px solid rgba(0, 0, 0, 0.2);
  border-radius: 4px;
  float: left;
  padding: 10px;
  margin: 4px 4px 4px 0px;
}

.divHidden{
  display:none;
}

.marginLeft {
  margin-left: 0px;
}

.marginRight {
  margin-right: 0px;
}

.mobileDivider {
  border-bottom: 1px solid var(--gray-03);
  margin: 12px 0;
}

.borderDivider {
  border: 1px solid rgba(0, 51, 102, 0.3);
  display: block;
  overflow: auto;
  @include breakpoints.desktop {
    display: none;
  }
}